/* directive/index.js 指令 */

// 操作权限处理
import hasPermission from "./permission/hasPermission";

// 注册全局指令
const install = (Vue) => {
  // 使用 Vue.directive 注册全局指令
  Vue.directive("hasPermission", hasPermission);
};

export default install;
